import React from "react";

const EnvironmentIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 11.325a2 2 0 0 1 2 2v1h12v-1a2 2 0 0 1 2-2m-16 0a2 2 0 0 0-2 2v5a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-5a2 2 0 0 0-2-2m-16 0v-3a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v3m-8-6v9"
    ></path>
  </svg>
);

export default EnvironmentIcon;
